module.exports = __webpack_public_path__ + "img/download-on-the-app-store-nl.c5a46154.svg";